import { attributesToProps } from 'html-react-parser';
import { Icon } from '@/app_components/common/Icon';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';
import { renderChild } from './parserOptions';

export const DetailParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { className, ...rest } = props;
  return (
    <details
      className={cn(
        'group typography-level-4 open:flex flex-col gap-sm [&>p]:typography-default not-prose-p:space-y-4 not-prose-p:font-inria-serif [&>p]:font-inria-serif',
        className,
      )}
      {...rest}
    >
      {renderChild(children)}
    </details>
  );
};

export const SummaryParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { className, ...rest } = props;
  return (
    <summary
      className={cn(
        'group-[.h3]:typography-level-3 group-[.h2]:typography-level-2 group-[.h3]:font-semibold group-[.h2]:font-semibold cursor-pointer list-none stroke-secondary border-b pb-1 font-graphik-compact font-semibold text-primary-hover [&_*]:text-primary-hover group-focus-within:text-accent md:group-focus-within:stroke-accent',
        'group-open:stroke-accent',
        className,
      )}
      {...rest}
    >
      <span className='flex items-center justify-between'>
        {renderChild(children)}
        <Icon
          className='transition-transform group-open:rotate-180 group-hover:stroke-accent'
          icon='ChevronDown'
        />
      </span>
    </summary>
  );
};
